import { render } from "./BrandVecernjiList.vue?vue&type=template&id=2113d118"
import script from "./BrandVecernjiList.vue?vue&type=script&lang=ts"
export * from "./BrandVecernjiList.vue?vue&type=script&lang=ts"

import "./BrandVecernjiList.vue?vue&type=style&index=0&id=2113d118&lang=scss"
script.render = render

export default script